<template>
  <form @submit.prevent="handleSubmit">
    <div class="mb-2">
      <v-input
        required
        placeholder="Password"
        v-model="password"
        type="password"
        name="password"
        autofocus
      ></v-input>
    </div>
    <div class="mb-2">
      <v-input
        required
        placeholder="Password Confirmation"
        v-model="passwordConfirmation"
        type="password"
        name="passwordConfirmation"
        autofocus
      ></v-input>
    </div>
    <v-button :is-loading="isLoading" block class="mb-2" type="submit">
      Set Password
    </v-button>
  </form>
</template>

<script>
import vInput from "@/components/forms/vInput"

export default {
  components: {
    vInput
  },

  data() {
    return {
      password: "",
      passwordConfirmation: "",
      isLoading: false
    }
  },

  methods: {
    handleSubmit() {
      this.isLoading = true

      if (this.password !== this.passwordConfirmation) {
        this.isLoading = false
        return this.$notify("Passwords don't match")
      } else if (this.password.length < 6) {
        this.isLoading = false
        this.$notify("Password must be longer than 6 characters.")
      } else {
        this.$emit("submit", {
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        })
        setTimeout(() => {
          this.isLoading = false
        }, 1500)
      }
    }
  }
}
</script>
